import type { WithdrawLockTransactionProps } from "@/components";
import { DIALOGS } from "@/types/dialog.types";
import { useDialogPortal } from "@/hooks";
import { useDisconnectedTokenForm } from "@/hooks";
import { useCallback } from "react";

interface UseWithdrawLockFormProps {
    existingLockAmount: number;
    existingLockDuration: number;
}

export function useWithdrawLockForm({ existingLockAmount, existingLockDuration }: UseWithdrawLockFormProps) {
    const { openDialog } = useDialogPortal();
    const { form, amount, amountError, setMaxAmount } = useDisconnectedTokenForm({
        maxValue: existingLockAmount.toString(),
    });

    const submitWithdrawLock = useCallback(
        () =>
            form.handleSubmit(() => {
                if (!amount.value) return;
                if (Number(amount.value) <= 0) return;
                if (amountError) return;

                const payload = {
                    withdrawLockAmount: Number(amount.value),
                    lockDuration: existingLockDuration,
                } satisfies WithdrawLockTransactionProps;

                openDialog({
                    dialogType: DIALOGS.WITHDRAW_LOCK_CONFIRM,
                    dialogProps: payload,
                });
            }),
        [form, amount, amountError, existingLockDuration, openDialog],
    );

    return {
        amount,
        amountError,
        submitWithdrawLock,
        setMaxAmount,
        isLoading: false,
    };
}
